module.exports = __webpack_public_path__ + "img/IMG_3605.99709d10.webp";